import { c as _c } from "react/compiler-runtime";
import React from 'react';
import DrawerContent from 'src/components/Organisms/DrawerContent/DrawerContent';
import { BlocksContent } from '@strapi/blocks-react-renderer';
import DrawerContentItem from 'src/components/Organisms/DrawerContentItem/DrawerContentItem';
export interface KnowledgeHubArticleProps {
  onClose: () => void;
  item?: {
    documentId: string;
    description?: string | null;
    richText?: BlocksContent | null;
    title?: string | null;
    subtitle?: string | null;
    media?: {
      alternativeText?: string | null;
      mime?: string | null;
      url?: string | null;
      formats?: {
        thumbnail?: {
          url?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
}
export const KnowledgeHubArticle: React.FC<KnowledgeHubArticleProps> = t0 => {
  const $ = _c(8);
  const {
    onClose,
    item
  } = t0;
  if (!item) {
    return null;
  }
  const t1 = item.title || "";
  let t2;
  if ($[0] !== onClose) {
    t2 = () => onClose();
    $[0] = onClose;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== item) {
    t3 = <DrawerContentItem item={item} />;
    $[2] = item;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <DrawerContent title={t1} onClose={t2}>{t3}</DrawerContent>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default KnowledgeHubArticle;